/* ==========================================================================
   STORIES UGC : logique (JavaScript natif, aucune dépendance)
   - Plusieurs rangées possibles sur une même page : [data-ugc-stories]
   - Une seule visionneuse partagée
   - Chaque story lit une vidéo MP4 ; sans vidéo, l'image s'affiche avec un lent zoom
   - Toucher à droite : suivante / à gauche : précédente / appui long : pause
   - Glisser vers le bas : fermer / Clavier : flèches, Espace, M, Échap
   ========================================================================== */
(function () {
  'use strict';

  // Snippet rendu deux fois sur la page : on initialise simplement la nouvelle rangée
  if (window.UGCStories) { window.UGCStories.boot(); return; }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Stories déjà vues pendant la visite.
  // Pour s'en souvenir d'une visite à l'autre, sauvegardez ce Set dans localStorage côté thème.
  var seen = new Set();
  var viewer = null;

  var ICONS = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    soundOn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5H4z" fill="currentColor"/><path d="M15.5 9a4.2 4.2 0 0 1 0 6"/><path d="M18.2 6.5a8 8 0 0 1 0 11"/></svg>',
    soundOff: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5H4z" fill="currentColor"/><path d="M16 9.5l5 5M21 9.5l-5 5"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6.5" y="5" width="3.6" height="14" rx="1"/><rect x="13.9" y="5" width="3.6" height="14" rx="1"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.2v13.6a.8.8 0 0 0 1.2.7l10.6-6.8a.8.8 0 0 0 0-1.4L9.2 4.5A.8.8 0 0 0 8 5.2z"/></svg>',
    left: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    right: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
  };

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Événements pour vos analytiques : écoutez "ugc:view", "ugc:add-to-cart"…
  // Sur Shopify, ils sont aussi publiés pour les pixels personnalisés (ugc_view, ugc_add_to_cart…).
  function track(name, detail) {
    document.dispatchEvent(new CustomEvent('ugc:' + name, { detail: detail }));
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('ugc_' + name.replace(/-/g, '_'), detail || {});
      }
    } catch (e) { /* analytique facultative */ }
  }

  // Rafraîchit le panier du thème après un ajout.
  // Thèmes Maestrooo (Impact, Prestige, Focal…) : événement cart:refresh.
  // Autres thèmes : adaptez ces lignes.
  // Formate un prix en cents avec le format monétaire du thème (window.themeVariables, thèmes Maestrooo)
  // ou, à défaut, celui de la boutique (Shopify.currency).
  function formatMoney(cents, format) {
    if (cents == null || isNaN(cents)) return '';
    format = format || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '${{amount}}';
    var value = cents / 100;
    function num(dec, thousands, decimal) {
      var parts = value.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var key = m ? m[1] : 'amount', out;
    switch (key) {
      case 'amount_no_decimals': out = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(0, '.', ','); break;
      case 'amount_with_space_separator': out = num(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = num(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = num(2, "'", '.'); break;
      default: out = num(2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '').trim();
  }

  // Variante courante : le champ `id` du formulaire produit désigné (formId), sinon le premier
  // formulaire d'ajout au panier de la page, sinon la valeur du JSON.
  function currentVariantId(data) {
    var p = data.product || {};
    var form = data.formId ? document.getElementById(data.formId) : null;
    if (!form) form = document.querySelector('form[action*="/cart/add"]');
    var input = form && form.elements ? form.elements.namedItem('id') : null;
    if (input && input.value) return input.value;
    return p.variantId;
  }

  // Préférence son du visiteur, valable pour la session (toutes les fiches produit) : true = muet, false = son.
  var SOUND_KEY = 'ugc:muted';
  function readSoundPref() {
    try { var v = sessionStorage.getItem(SOUND_KEY); return v === null ? null : v === '1'; } catch (e) { return null; }
  }
  function writeSoundPref(muted) {
    try { sessionStorage.setItem(SOUND_KEY, muted ? '1' : '0'); } catch (e) {}
  }

  function refreshThemeCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }
  function openThemeCart(url) {
    var drawer = document.querySelector('cart-drawer, #cart-drawer');
    if (drawer && typeof drawer.show === 'function') { drawer.show(); return; }
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    window.location.href = url || '/cart';
  }

  /* ---------------------------------------------------------------------- */
  function StoryViewer() {
    var el = document.createElement('div');
    el.className = 'ugc-viewer';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Vidéos de nos clients');
    el.innerHTML =
      '<div class="ugc-viewer__backdrop" data-ugc-backdrop></div>' +
      '<button type="button" class="ugc-viewer__nav" data-ugc-prev aria-label="Vidéo précédente">' + ICONS.left + '</button>' +
      '<div class="ugc-viewer__frame">' +
        '<div class="ugc-viewer__media">' +
          '<img class="ugc-viewer__poster" alt="" decoding="async">' +
          '<video class="ugc-viewer__video" playsinline webkit-playsinline muted preload="auto"></video>' +
        '</div>' +
        '<div class="ugc-viewer__spinner" aria-hidden="true"></div>' +
        '<div class="ugc-viewer__chrome">' +
          '<div>' +
            '<div class="ugc-viewer__progress" aria-hidden="true"></div>' +
            '<div class="ugc-viewer__header">' +
              '<img class="ugc-viewer__avatar" alt="">' +
              '<p class="ugc-viewer__who"><span class="ugc-viewer__name"></span><span class="ugc-viewer__meta"></span></p>' +
              '<button type="button" class="ugc-viewer__icon" data-ugc-mute aria-label="Activer le son">' + ICONS.soundOff + '</button>' +
              '<button type="button" class="ugc-viewer__icon" data-ugc-pause aria-label="Mettre en pause">' + ICONS.pause + '</button>' +
              '<button type="button" class="ugc-viewer__icon" data-ugc-close aria-label="Fermer">' + ICONS.close + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="ugc-viewer__bottom">' +
            '<button type="button" class="ugc-viewer__sound-hint" data-ugc-sound-hint hidden>' + ICONS.soundOff + '<span>Activer le son</span></button>' +
            '<p class="ugc-viewer__caption"></p>' +
            '<div class="ugc-viewer__product">' +
              '<img class="ugc-viewer__product-img" alt="">' +
              '<div class="ugc-viewer__product-info">' +
                '<a class="ugc-viewer__product-title" href="#"></a>' +
                '<span class="ugc-viewer__product-sub"></span>' +
                '<span class="ugc-viewer__product-price"><strong></strong><s></s></span>' +
              '</div>' +
              '<button type="button" class="ugc-viewer__product-btn" data-ugc-add></button>' +
            '</div>' +
            '<p class="ugc-viewer__status" role="status"></p>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="ugc-viewer__nav" data-ugc-next aria-label="Vidéo suivante">' + ICONS.right + '</button>' +
      '<p class="ugc-visually-hidden" aria-live="polite" data-ugc-live></p>';
    document.body.appendChild(el);

    var q = function (s) { return el.querySelector(s); };
    this.el = el;
    this.frame = q('.ugc-viewer__frame');
    this.media = q('.ugc-viewer__media');
    this.poster = q('.ugc-viewer__poster');
    this.video = q('.ugc-viewer__video');
    this.progress = q('.ugc-viewer__progress');
    this.avatar = q('.ugc-viewer__avatar');
    this.nameEl = q('.ugc-viewer__name');
    this.metaEl = q('.ugc-viewer__meta');
    this.caption = q('.ugc-viewer__caption');
    this.card = q('.ugc-viewer__product');
    this.cardImg = q('.ugc-viewer__product-img');
    this.cardTitle = q('.ugc-viewer__product-title');
    this.cardSub = q('.ugc-viewer__product-sub');
    this.cardPrice = q('.ugc-viewer__product-price strong');
    this.cardCompare = q('.ugc-viewer__product-price s');
    this.cardBtn = q('[data-ugc-add]');
    this.status = q('.ugc-viewer__status');
    this.btnMute = q('[data-ugc-mute]');
    this.btnPause = q('[data-ugc-pause]');
    this.btnClose = q('[data-ugc-close]');
    this.btnPrev = q('[data-ugc-prev]');
    this.btnNext = q('[data-ugc-next]');
    this.live = q('[data-ugc-live]');

    this.preloader = document.createElement('video');
    this.preloader.muted = true;
    this.preloader.preload = 'metadata';

    this.isOpen = false;
    this.index = 0;
    this.pauses = new Set();
    this.muted = null;
    this.elapsed = 0;
    this.last = 0;
    this.raf = 0;
    this.tick = this.tick.bind(this);
    this.onKey = this.onKey.bind(this);
    this.bind();
  }

  StoryViewer.prototype.bind = function () {
    var self = this;
    document.addEventListener('variant:change', function (e) { self.onVariantChange(e); });
    this.btnClose.addEventListener('click', function () { self.close(); });
    this.el.querySelector('[data-ugc-backdrop]').addEventListener('click', function () { self.close(); });
    this.btnPrev.addEventListener('click', function () { self.prev(); });
    this.btnNext.addEventListener('click', function () { self.next(); });
    this.btnMute.addEventListener('click', function () { self.setMuted(!self.muted, true); });
    this.soundHint = this.el.querySelector('[data-ugc-sound-hint]');
    this.soundHint.addEventListener('click', function () { self.setMuted(false, true); });
    this.btnPause.addEventListener('click', function () {
      self.pauses.has('user') ? self.resume('user') : self.pause('user');
    });
    this.cardBtn.addEventListener('click', function () { self.onCartButton(); });
    this.cardTitle.addEventListener('click', function (e) {
      var url = self.data && self.data.product && self.data.product.url;
      var samePage = !url || new URL(url, location.href).pathname === location.pathname;
      if (samePage) { e.preventDefault(); self.close(); }
    });

    this.poster.addEventListener('error', function () { self.poster.classList.add('is-broken'); });
    this.poster.addEventListener('load', function () { self.poster.classList.remove('is-broken'); });
    this.avatar.addEventListener('error', function () { self.avatar.style.visibility = 'hidden'; });
    this.avatar.addEventListener('load', function () { self.avatar.style.visibility = ''; });
    this.cardImg.addEventListener('error', function () { self.cardImg.style.visibility = 'hidden'; });

    this.video.addEventListener('playing', function () {
      self.setLoading(false);
      self.media.classList.add('has-video');
    });
    this.video.addEventListener('waiting', function () { self.setLoading(true); });
    this.video.addEventListener('canplay', function () { self.setLoading(false); });
    this.video.addEventListener('ended', function () { if (self.isOpen) self.next(); });
    this.video.addEventListener('error', function () {
      // Vidéo introuvable : on bascule sur l'image pour ne pas bloquer la séquence
      if (self.mode === 'video' && self.video.getAttribute('src')) self.useImage();
    });

    this.frame.addEventListener('pointerdown', function (e) { self.onDown(e); });
    this.frame.addEventListener('pointermove', function (e) { self.onMove(e); });
    this.frame.addEventListener('pointerup', function (e) { self.onUp(e, false); });
    this.frame.addEventListener('pointercancel', function (e) { self.onUp(e, true); });
    this.frame.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    document.addEventListener('visibilitychange', function () {
      if (!self.isOpen) return;
      document.hidden ? self.pause('hidden') : self.resume('hidden');
    });
  };

  StoryViewer.prototype.open = function (data, index, trigger) {
    clearTimeout(this.hideTimer);
    this.data = data;
    this.stories = data.stories;
    this.trigger = trigger || null;
    if (this.muted === null) {
      // Choix du visiteur mémorisé pour la session (voir setMuted), sinon réglage du bloc.
      var saved = readSoundPref();
      this.muted = saved === null ? data.muted !== false : saved;
    }
    this.setMuted(this.muted);
    this.hintShown = false;
    this.buildProgress();
    this.fillProduct();
    this.pauses.clear();
    this.el.classList.remove('is-paused', 'is-holding');
    this.el.hidden = false;
    document.documentElement.classList.add('ugc-lock');
    document.addEventListener('keydown', this.onKey);
    this.isOpen = true;
    var el = this.el;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    this.go(index || 0);
    this.last = performance.now();
    cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(this.tick);
    this.btnClose.focus({ preventScroll: true });
    track('open', { index: index, id: this.stories[index] && this.stories[index].id });
  };

  StoryViewer.prototype.close = function () {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    cancelAnimationFrame(this.raf);
    clearTimeout(this.holdTimer);
    this.video.pause();
    this.video.removeAttribute('src');
    this.video.load();
    this.frame.style.transform = '';
    this.el.style.removeProperty('--ugc-drag');
    this.el.classList.remove('is-open', 'is-holding', 'is-loading', 'is-dragging');
    document.removeEventListener('keydown', this.onKey);
    document.documentElement.classList.remove('ugc-lock');
    this.hideTimer = setTimeout(function () { self.el.hidden = true; }, reduceMotion.matches ? 0 : 200);
    if (this.trigger && document.contains(this.trigger)) this.trigger.focus({ preventScroll: true });
    track('close', { index: this.index });
  };

  StoryViewer.prototype.buildProgress = function () {
    this.progress.innerHTML = this.stories.map(function () {
      return '<span class="ugc-viewer__seg"><i></i></span>';
    }).join('');
    this.bars = Array.prototype.slice.call(this.progress.querySelectorAll('i'));
  };

  StoryViewer.prototype.onVariantChange = function (e) {
    var d = e && e.detail, v = d && d.variant, p = this.data.product;
    if (!v || !p) return;
    if (this.data.formId && d.formId && d.formId !== this.data.formId) return;
    p.variantId = v.id;
    if (typeof v.available === 'boolean') p.available = v.available;
    if (typeof v.price === 'number') {
      p.price = formatMoney(v.price);
      p.compareAtPrice = (v.compare_at_price && v.compare_at_price > v.price) ? formatMoney(v.compare_at_price) : '';
    }
    if (v.featured_image && v.featured_image.src) p.image = v.featured_image.src;
    if (this.isOpen) this.fillProduct();
  };

  StoryViewer.prototype.fillProduct = function () {
    var p = this.data.product;
    this.status.textContent = '';
    this.cardBtn.classList.remove('is-added');
    if (!p) { this.card.hidden = true; return; }
    this.card.hidden = false;
    this.cardImg.style.visibility = '';
    this.cardImg.src = p.image || '';
    this.cardTitle.textContent = p.title || '';
    this.cardTitle.href = p.url || '#';
    this.cardSub.textContent = p.subtitle || '';
    this.cardSub.hidden = !p.subtitle;
    this.cardPrice.textContent = p.price || '';
    this.cardCompare.textContent = p.compareAtPrice || '';
    this.cardBtn.textContent = p.available === false ? 'Épuisé' : (p.cta || 'Ajouter au panier');
    this.cardBtn.disabled = p.available === false;
  };

  StoryViewer.prototype.go = function (i) {
    var n = this.stories.length;
    if (i >= n) { this.close(); return; }
    if (i < 0) i = 0;
    this.index = i;
    var s = this.stories[i];

    this.pauses.delete('user');
    this.pauses.delete('hold');
    if (!this.pauses.size) this.el.classList.remove('is-paused');
    this.syncPauseButton();

    for (var j = 0; j < this.bars.length; j++) {
      this.bars[j].style.transform = 'scaleX(' + (j < i ? 1 : 0) + ')';
    }

    this.avatar.src = s.avatar || s.thumb || s.poster || '';
    this.nameEl.textContent = s.creator || s.label || '';
    this.metaEl.textContent = s.meta || 'Vidéo client';
    this.caption.textContent = s.caption || '';
    this.caption.hidden = !s.caption;

    var duration = Number(s.duration) || Number(this.data.imageDuration) || 6;
    this.el.style.setProperty('--ugc-duration', duration + 's');
    this.duration = duration;
    this.elapsed = 0;

    this.media.classList.remove('has-video');
    this.poster.src = s.poster || '';
    this.poster.style.animation = 'none';
    void this.poster.offsetWidth; // relance le zoom lent
    this.poster.style.animation = '';

    if (s.video) {
      this.mode = 'video';
      this.el.classList.remove('is-image');
      this.btnMute.hidden = false;
      this.setLoading(true);
      this.video.muted = this.muted;
      this.video.src = s.video;
      if (!this.pauses.size) this.playVideo();
      this.showSoundHint();
    } else {
      this.useImage();
    }

    this.btnPrev.disabled = i === 0;
    this.markSeen(s);
    this.live.textContent = 'Vidéo ' + (i + 1) + ' sur ' + n +
      (s.label ? ' : ' + s.label : '') + (s.creator ? ', par ' + s.creator : '');
    this.preload(i + 1);
    track('view', { index: i, id: s.id, label: s.label });
  };

  StoryViewer.prototype.useImage = function () {
    this.mode = 'image';
    this.el.classList.add('is-image');
    this.setLoading(false);
    this.media.classList.remove('has-video');
    this.video.pause();
    if (this.video.getAttribute('src')) {
      this.video.removeAttribute('src');
      this.video.load();
    }
    this.btnMute.hidden = true;
  };

  StoryViewer.prototype.playVideo = function () {
    var self = this;
    this.btnMute.hidden = false;
    var attempt = this.video.play();
    if (!attempt || !attempt.catch) return;
    attempt.catch(function (err) {
      if (!self.isOpen || (err && err.name === 'AbortError')) return; // on a changé de story entre-temps
      if (err && err.name === 'NotSupportedError') return;           // source illisible : l'événement `error` bascule sur l'image
      if (!self.video.muted) {
        // Politique de lecture automatique : le navigateur refuse le son → on relance en muet
        // (sans mémoriser ce repli comme un choix du visiteur)
        self.setMuted(true);
        self.video.play().catch(function () { self.pause('user'); });
      } else {
        self.pause('user');
      }
    });
  };

  StoryViewer.prototype.next = function () { this.go(this.index + 1); };
  StoryViewer.prototype.prev = function () { this.go(this.index - 1); };

  StoryViewer.prototype.pause = function (reason) {
    this.pauses.add(reason);
    if (this.mode === 'video') this.video.pause();
    this.el.classList.add('is-paused');
    this.syncPauseButton();
  };

  StoryViewer.prototype.resume = function (reason) {
    this.pauses.delete(reason);
    this.syncPauseButton();
    if (this.pauses.size || !this.isOpen) return;
    this.el.classList.remove('is-paused');
    this.last = performance.now();
    if (this.mode === 'video') this.playVideo();
  };

  StoryViewer.prototype.syncPauseButton = function () {
    var paused = this.pauses.has('user');
    this.btnPause.innerHTML = paused ? ICONS.play : ICONS.pause;
    this.btnPause.setAttribute('aria-label', paused ? 'Lire' : 'Mettre en pause');
  };

  // Indice « Activer le son » : affiché sur la première vidéo muette de chaque ouverture, 4 s max.
  StoryViewer.prototype.showSoundHint = function () {
    var self = this;
    clearTimeout(this.hintTimer);
    if (!this.muted || this.hintShown || readSoundPref() === false) { this.soundHint.hidden = true; return; }
    this.hintShown = true;
    this.soundHint.hidden = false;
    this.hintTimer = setTimeout(function () { self.soundHint.hidden = true; }, 4000);
  };

  // `byUser` : le visiteur a choisi (bouton, pastille, touche M) → on retient son choix pour la
  // session. Sans `byUser` (repli du navigateur qui refuse le son), on ne retient rien.
  StoryViewer.prototype.setMuted = function (muted, byUser) {
    this.muted = muted;
    this.video.muted = muted;
    if (byUser) writeSoundPref(muted);
    if (!muted && this.soundHint) { clearTimeout(this.hintTimer); this.soundHint.hidden = true; }
    this.btnMute.innerHTML = muted ? ICONS.soundOff : ICONS.soundOn;
    this.btnMute.setAttribute('aria-label', muted ? 'Activer le son' : 'Couper le son');
  };

  StoryViewer.prototype.setLoading = function (on) {
    this.el.classList.toggle('is-loading', !!on);
  };

  StoryViewer.prototype.tick = function (now) {
    if (!this.isOpen) return;
    var dt = Math.min(now - this.last, 100); // pas de saut après un onglet en arrière-plan
    this.last = now;
    var p = 0;
    if (this.mode === 'video') {
      var d = this.video.duration;
      p = d && isFinite(d) ? this.video.currentTime / d : 0;
    } else {
      if (!this.pauses.size) this.elapsed += dt;
      p = this.elapsed / (this.duration * 1000);
      if (p >= 1) {
        this.next();
        if (!this.isOpen) return;
        p = 0;
      }
    }
    var bar = this.bars[this.index];
    if (bar) bar.style.transform = 'scaleX(' + Math.min(p, 1) + ')';
    this.raf = requestAnimationFrame(this.tick);
  };

  StoryViewer.prototype.markSeen = function (s) {
    var key = String(s.id);
    if (seen.has(key)) return;
    seen.add(key);
    var bubbles = document.querySelectorAll('.ugc-bubble[data-story-id]');
    for (var i = 0; i < bubbles.length; i++) {
      if (bubbles[i].getAttribute('data-story-id') === key) bubbles[i].classList.add('is-seen');
    }
  };

  StoryViewer.prototype.preload = function (i) {
    var s = this.stories[i];
    if (!s) return;
    if (s.poster) { var img = new Image(); img.src = s.poster; }
    var saveData = navigator.connection && navigator.connection.saveData;
    if (s.video && !saveData) this.preloader.src = s.video;
  };

  /* --- Gestes ---------------------------------------------------------- */
  StoryViewer.prototype.onDown = function (e) {
    if (e.button > 0) return;
    if (e.target.closest('button, a, .ugc-viewer__product')) return;
    var self = this;
    this.gesture = { id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, dy: 0, moved: false, held: false };
    try { this.frame.setPointerCapture(e.pointerId); } catch (err) { /* ignoré */ }
    clearTimeout(this.holdTimer);
    this.holdTimer = setTimeout(function () {
      if (!self.gesture || self.gesture.moved) return;
      self.gesture.held = true;
      self.pause('hold');
      self.el.classList.add('is-holding');
    }, 200);
  };

  StoryViewer.prototype.onMove = function (e) {
    var g = this.gesture;
    if (!g || e.pointerId !== g.id) return;
    g.dx = e.clientX - g.x;
    g.dy = e.clientY - g.y;
    if (!g.moved && Math.hypot(g.dx, g.dy) > 8) {
      g.moved = true;
      clearTimeout(this.holdTimer);
    }
    if (g.moved && !g.held && g.dy > 0 && g.dy > Math.abs(g.dx)) {
      this.el.classList.add('is-dragging');
      this.frame.style.transform = 'translateY(' + (g.dy * 0.6) + 'px) scale(' + (1 - Math.min(g.dy / 2400, 0.06)) + ')';
      this.el.style.setProperty('--ugc-drag', Math.min(g.dy / 400, 1));
    }
  };

  StoryViewer.prototype.onUp = function (e, cancelled) {
    var g = this.gesture;
    if (!g || e.pointerId !== g.id) return;
    this.gesture = null;
    clearTimeout(this.holdTimer);
    this.el.classList.remove('is-dragging');
    this.frame.style.transform = '';
    this.el.style.removeProperty('--ugc-drag');

    if (g.held) {
      this.el.classList.remove('is-holding');
      this.resume('hold');
      return;
    }
    if (cancelled) return;
    if (g.dy > 110 && g.dy > Math.abs(g.dx)) { this.close(); return; }
    if (Math.abs(g.dx) > 60 && Math.abs(g.dx) > Math.abs(g.dy)) {
      g.dx < 0 ? this.next() : this.prev();
      return;
    }
    if (!g.moved) {
      var r = this.frame.getBoundingClientRect();
      (e.clientX - r.left) < r.width * 0.3 ? this.prev() : this.next();
    }
  };

  StoryViewer.prototype.onKey = function (e) {
    var onControl = e.target && e.target.closest && e.target.closest('button, a');
    switch (e.key) {
      case 'Escape': e.preventDefault(); this.close(); break;
      case 'ArrowRight': e.preventDefault(); this.next(); break;
      case 'ArrowLeft': e.preventDefault(); this.prev(); break;
      case ' ':
        if (onControl) return;
        e.preventDefault();
        this.btnPause.click();
        break;
      case 'm': case 'M':
        if (this.mode === 'video') this.setMuted(!this.muted, true);
        break;
      case 'Tab': this.trapFocus(e); break;
    }
  };

  StoryViewer.prototype.trapFocus = function (e) {
    var items = Array.prototype.filter.call(
      this.el.querySelectorAll('button, a[href]'),
      function (x) { return !x.disabled && !x.hidden && x.getClientRects().length > 0; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!this.el.contains(active)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  };

  /* --- Panier ---------------------------------------------------------- */
  StoryViewer.prototype.onCartButton = function () {
    var self = this;
    var p = this.data.product;
    var btn = this.cardBtn;
    if (!p || btn.disabled) return;

    if (btn.classList.contains('is-added')) {
      var evt = new CustomEvent('ugc:open-cart', { cancelable: true, detail: p });
      var proceed = document.dispatchEvent(evt);
      this.close();
      if (proceed) openThemeCart(this.data.cartUrl);
      return;
    }

    var label = btn.textContent;
    this.pause('cart');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Ajout en cours…';
    this.status.textContent = '';

    // Variante courante : on lit le sélecteur du formulaire produit du thème
    // (mis à jour quand le client change de couleur/format), sinon la valeur du JSON.
    var variantId = currentVariantId(this.data);

    var request;
    if (this.data.demo) {
      request = new Promise(function (resolve) { setTimeout(resolve, 600); });
    } else {
      request = fetch(this.data.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw new Error(json.description || json.message || 'Erreur ' + res.status);
          refreshThemeCart();
          return json;
        });
      });
    }

    request.then(function () {
      btn.classList.add('is-added');
      btn.textContent = 'Voir le panier';
      self.status.textContent = (p.title || 'Le produit') + ' est dans votre panier.';
      track('add-to-cart', { id: self.stories[self.index].id, variantId: variantId });
      document.dispatchEvent(new CustomEvent('ugc:cart-added', { detail: p }));
    }).catch(function (err) {
      btn.textContent = label;
      self.status.textContent = 'Ajout impossible. ' + (err && err.message ? err.message : 'Réessayez.');
    }).then(function () {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      self.resume('cart');
    });
  };

  /* ---------------------------------------------------------------------- */
  function getViewer() {
    return viewer || (viewer = new StoryViewer());
  }

  function bubbleHTML(s, i) {
    var label = esc(s.label || '');
    var by = s.creator ? ', par ' + esc(s.creator) : '';
    return '<li>' +
      '<button type="button" class="ugc-bubble" data-index="' + i + '" data-story-id="' + esc(s.id) + '" style="--i:' + i + '" aria-label="Regarder la vidéo ' + label + by + '">' +
        '<span class="ugc-bubble__ring">' +
          '<span class="ugc-bubble__photo"><img src="' + esc(s.thumb || s.poster) + '" alt="" width="160" height="160" loading="lazy"></span>' +
          '<span class="ugc-bubble__play" aria-hidden="true">' + ICONS.play + '</span>' +
        '</span>' +
        '<span class="ugc-bubble__label">' + label + '</span>' +
      '</button>' +
    '</li>';
  }

  function watchOverflow(list) {
    var update = function () {
      list.classList.toggle('is-overflowing', list.scrollWidth > list.clientWidth + 2);
      list.classList.toggle('is-at-end', list.scrollLeft + list.clientWidth >= list.scrollWidth - 2);
    };
    update();
    list.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
    else window.addEventListener('resize', update);
  }

  var revealObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.6 }) : null;

  function init(root) {
    if (root.__ugcReady) return;
    var sourceSelector = root.getAttribute('data-ugc-source');
    var source = root.querySelector('script[type="application/json"]') ||
      (sourceSelector ? document.querySelector(sourceSelector) : null);
    if (!source) return;
    var data;
    try { data = JSON.parse(source.textContent); }
    catch (err) { console.warn('[Stories UGC] Données JSON invalides', err); return; }
    if (!data.stories || !data.stories.length) { root.hidden = true; return; }

    // Normalisation : si un champ texte arrive sous forme d'objet ({ value: '…' }), on prend la valeur.
    var str = function (v) {
      if (v == null) return '';
      if (typeof v === 'object') return str(v.value);
      return String(v);
    };
    data.stories.forEach(function (s) {
      s.label = str(s.label); s.creator = str(s.creator); s.caption = str(s.caption);
      s.video = str(s.video); s.poster = str(s.poster); s.thumb = str(s.thumb); s.avatar = str(s.avatar);
    });
    root.__ugcReady = true;

    data.stories.forEach(function (s, i) { if (!s.id) s.id = 'story-' + i; });

    var list = root.querySelector('.ugc-stories__list');
    if (!list.children.length) list.innerHTML = data.stories.map(bubbleHTML).join('');
    list.querySelectorAll('.ugc-bubble').forEach(function (b) {
      if (seen.has(b.getAttribute('data-story-id'))) b.classList.add('is-seen');
    });
    list.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('error', function () { img.classList.add('is-broken'); }, { once: true });
    });

    var count = root.querySelector('[data-ugc-count]');
    if (count && !count.textContent.trim()) {
      var n = data.stories.length;
      // Un compteur « 1 vidéo » n'apporte rien : on ne l'affiche qu'à partir de deux.
      count.textContent = n + ' vidéos';
      count.hidden = n < 2;
    }

    list.addEventListener('click', function (e) {
      var bubble = e.target.closest('.ugc-bubble');
      if (!bubble) return;
      getViewer().open(data, Number(bubble.getAttribute('data-index')) || 0, bubble);
    });

    watchOverflow(list);
    if (revealObserver && !reduceMotion.matches) revealObserver.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-ugc-stories]').forEach(init);
  }

  window.UGCStories = { boot: boot, init: init, track: track };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Éditeur de thème Shopify : sections rechargées à chaud
  document.addEventListener('shopify:section:load', boot);

  // Les thèmes qui re-rendent la fiche produit (ex. <product-rerender> d'Impact) ou qui
  // injectent des sections à la volée (achat rapide) remplacent le DOM sans événement :
  // on relance boot() (idempotent) dès qu'une rangée non initialisée apparaît.
  if (window.MutationObserver) {
    var bootTimer = null;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute('data-ugc-stories') || n.querySelector('[data-ugc-stories]')) {
            clearTimeout(bootTimer);
            bootTimer = setTimeout(boot, 30);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();